"use client";

import { c as _c } from "react/compiler-runtime";
import type { Genre } from "@filmweb/sanity-types";
import classNames from "classnames";
import { format, parseISO } from "date-fns";
import FilmwebLink from "src/components/filmweblink/FilmwebLink";
import { useLocationContext, useUserContext } from "src/lib/contexts/ContextTypes";
import { ensureBookingCorrelationToken } from "src/lib/filmwebid/bookingCorrelationToken";
import { locale } from "src/lib/locale/date-fns";
import { type Show, type VersionTag } from "src/lib/movieinfo/movieinfotypes";
import styles from "./Show.module.css";
import getThemeStyles from "src/lib/styling/getThemeStyles";
const BRAND = process.env.NEXT_PUBLIC_WEBSITE_BRAND;

//#region [Props]
type ShowProps = {
  show: Show;
  isKinoklubbMovie?: boolean;
  genres?: Genre[];
  className?: string;
  style?: React.CSSProperties;
  hideTheatreName?: boolean;
};
//#endregion

//#region [Component]
export default function Show(t0) {
  const $ = _c(47);
  const {
    show,
    isKinoklubbMovie: t1,
    genres,
    className,
    style,
    hideTheatreName: t2
  } = t0;
  const isKinoklubbMovie = t1 === undefined ? false : t1;
  const hideTheatreName = t2 === undefined ? false : t2;
  const locationContext = useLocationContext();
  const disableShowLink = !show.ticketSaleUrl;
  let t3;
  if ($[0] !== show.showStart) {
    t3 = format(parseISO(show.showStart), "EEE dd.MM", {
      locale
    });
    $[0] = show.showStart;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const _showDate = t3;
  let t4;
  if ($[2] !== show.showStart) {
    t4 = show.showStart?.substring(11, 16);
    $[2] = show.showStart;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const _showTime = t4;
  let t5;
  if ($[4] !== show) {
    t5 = getVersionName(show);
    $[4] = show;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const versionName = t5;
  const isKinoklubb = process.env.NEXT_PUBLIC_KINOKLUBB_ENABLED === "true" && show.isKinoklubb && isKinoklubbMovie;
  const themeStyles = getThemeStyles(styles, {
    [styles.isKinoklubb]: isKinoklubb
  });
  const ticketUrl = useTicketUrl(show);
  const T0 = FilmwebLink;
  const t6 = "_blank";
  let t7;
  if ($[6] !== disableShowLink || $[7] !== genres || $[8] !== show) {
    t7 = () => !disableShowLink ? trackSale(show, genres) : false;
    $[6] = disableShowLink;
    $[7] = genres;
    $[8] = show;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = classNames(styles.SShow, className, themeStyles);
  let t9;
  if ($[10] !== isKinoklubb) {
    t9 = classNames(styles.InnerContainer, {
      [styles.isKinoklubb]: isKinoklubb,
      "isKinoklubb": isKinoklubb
    });
    $[10] = isKinoklubb;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== isKinoklubb) {
    t10 = classNames(styles.STime, {
      [styles.SKKTime]: isKinoklubb
    });
    $[12] = isKinoklubb;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== _showTime || $[15] !== t10) {
    t11 = <div className={t10}>{_showTime}</div>;
    $[14] = _showTime;
    $[15] = t10;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== _showDate || $[18] !== locationContext.showAllDates) {
    t12 = locationContext.showAllDates && <div className={styles.Date}>{_showDate}</div>;
    $[17] = _showDate;
    $[18] = locationContext.showAllDates;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t11 || $[21] !== t12) {
    t13 = <div className={styles.TimeContainer}>{t11}{t12}</div>;
    $[20] = t11;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== locationContext.location) {
    t14 = classNames(styles.SScreenName, hasMultipleLocations(locationContext.location) && styles.isMultiLocation);
    $[23] = locationContext.location;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== hideTheatreName || $[26] !== show) {
    t15 = getScreenName(show, hideTheatreName);
    $[25] = hideTheatreName;
    $[26] = show;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t14 || $[29] !== t15) {
    t16 = <div className={t14}>{t15}</div>;
    $[28] = t14;
    $[29] = t15;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== versionName) {
    t17 = versionName && <div className={styles.SVersionInfo}>{versionName}</div>;
    $[31] = versionName;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t16 || $[34] !== t17) {
    t18 = <div className={styles.SScreenLine}>{t16}{t17}</div>;
    $[33] = t16;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== t13 || $[37] !== t18 || $[38] !== t9) {
    t19 = <div className={t9}>{t13}{t18}</div>;
    $[36] = t13;
    $[37] = t18;
    $[38] = t9;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== T0 || $[41] !== style || $[42] !== t19 || $[43] !== t7 || $[44] !== t8 || $[45] !== ticketUrl) {
    t20 = <T0 to={ticketUrl} target={t6} onClick={t7} className={t8} style={style}>{t19}</T0>;
    $[40] = T0;
    $[41] = style;
    $[42] = t19;
    $[43] = t7;
    $[44] = t8;
    $[45] = ticketUrl;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  return t20;
}
//#endregion

const EXCLUDE_TAGS = BRAND === "kinodk" ? ["Dansk tekst", "2D"] : ["Norsk tekst", "2D"];
function hasMultipleLocations(location: string[] | null | undefined): boolean {
  return (location?.length ?? 0) > 1 || (location?.includes("Oslo og omegn") ?? false);
}

// empty urls will end up rendered as divs
function useTicketUrl_kinodk(show) {
  const $ = _c(3);
  const {
    userCorrelationToken
  } = useUserContext();
  if (!show.ticketSaleUrl) {
    return "";
  }
  let t0;
  if ($[0] !== show.ticketSaleUrl || $[1] !== userCorrelationToken) {
    t0 = ensureBookingCorrelationToken(show.ticketSaleUrl, userCorrelationToken);
    $[0] = show.ticketSaleUrl;
    $[1] = userCorrelationToken;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}
// empty urls will end up rendered as divs
function useTicketUrl_filmweb(show: Show): string {
  const query = `utm_source=Filmweb&utm_campaign=Filmweb&utm_medium=${show.theaterName}&utm_content=${show.movieTitle!}&sender=Filmweb`;
  if (/\?/.test(show.ticketSaleUrl!)) {
    return `${show.ticketSaleUrl!}&${query}`;
  } else {
    return `${show.ticketSaleUrl!}?${query}`;
  }
}
const isKinoDk = process.env.NEXT_PUBLIC_WEBSITE_BRAND === "kinodk";
const useTicketUrl: (show: Show) => string = isKinoDk ? useTicketUrl_kinodk : useTicketUrl_filmweb;
function getScreenName(show: Show, hideTheatreName: boolean = false): string {
  if (!show.theaterName?.trim() && show.screenName) {
    return show.screenName!;
  }
  if (!hideTheatreName && !show.screenName?.trim() && show.theaterName) {
    return show.theaterName!;
  }
  if (show.screenName?.toLocaleLowerCase().trim().startsWith(show.theaterName?.toLocaleLowerCase().trim() ?? "")) {
    return show.screenName!;
  }
  const theatreParts = hideTheatreName ? [] : show.theaterName?.split(" ")?.map(p => p?.trim())?.filter(p => !!p) ?? [];
  const screenParts = show.screenName?.split(" ")?.map(p => p?.trim())?.filter(p => !!p) ?? [];
  const theatreEndPart = theatreParts.at(-1);
  const screenEndPart = screenParts[0];
  if (screenEndPart && theatreEndPart?.toLocaleLowerCase() === screenEndPart?.toLocaleLowerCase()) {
    //console.debug("JOINING", theatreParts, screenParts);
    return theatreParts.join(" ") + " " + screenParts.slice(1).join(" ");
  }
  return (hideTheatreName ? "" : show.theaterName + " ") + show.screenName;
}
function getVersionName(show: Show) {
  const versionTags = (show.versionTags?.filter(versionTag => !EXCLUDE_TAGS.includes(versionTag!.tag!))?.map(versionTag => {
    if (versionTag?.type === "DUB" && !versionTag.tag?.endsWith(" tale")) {
      return {
        ...versionTag,
        tag: `${versionTag.tag?.trim()} tale`
      };
    }
    return versionTag;
  }) ?? []) as VersionTag[];
  versionTags.sort((a, b) => {
    if (a.tag!.endsWith(" tale") && !b.tag!.endsWith(" tale")) {
      return -1;
    }
    if (!a.tag!.endsWith(" tale") && b.tag!.endsWith(" tale")) {
      return 1;
    }
    if (a.tag!.includes("tekst") && !b.tag!.includes("tekst")) {
      return 1;
    }
    if (!a.tag!.includes("tekst") && b.tag!.includes("tekst")) {
      return -1;
    }
    return 0;
  });
  if (show.showType) versionTags.push({
    tag: show.showType,
    type: ""
  });
  const versionText = versionTags.length === 0 ? null : versionTags.map(t => t.tag).join(", ");
  return versionText;
}
function trackSale(show: Show, genres: Genre[] | undefined) {
  window?.dataLayer?.push({
    'event': 'Billettsalg',
    'eventCategory': 'Billettsalg',
    'eventAction': `${show.firmName} ${show.theaterName}`,
    'eventLabel': show.movieTitle,
    'eventGenres': genres?.map(g => g.name)?.join(" / ") ?? "",
    'eventEdi': show.movieVersionId
  });
}